var map = {
  "./desktop/Cartoons.js": [
    "97405",
    9,
    "9598",
    "11088",
    "45681",
    "3091"
  ],
  "./desktop/index.js": [
    "87572",
    9,
    "9598",
    "76225",
    "62815",
    "11088",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45681",
    "3091",
    "64224",
    "42879"
  ],
  "./desktop/index": [
    "87572",
    9,
    "9598",
    "76225",
    "62815",
    "11088",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45681",
    "3091",
    "64224",
    "42879"
  ],
  "./mobile/Cartoons.js": [
    "83259",
    9,
    "9598",
    "45681",
    "74504",
    "57625"
  ],
  "./mobile/index": [
    "69402",
    9,
    "9598",
    "11975",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "45681",
    "64224",
    "74504",
    "58857"
  ],
  "./mobile/index.js": [
    "69402",
    9,
    "9598",
    "11975",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "45681",
    "64224",
    "74504",
    "58857"
  ],
  "./mobile": [
    "69402",
    9,
    "9598",
    "11975",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "45681",
    "64224",
    "74504",
    "58857"
  ],
  "./desktop": [
    "87572",
    9,
    "9598",
    "76225",
    "62815",
    "11088",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45681",
    "3091",
    "64224",
    "42879"
  ],
  "./desktop/": [
    "87572",
    9,
    "9598",
    "76225",
    "62815",
    "11088",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "45681",
    "3091",
    "64224",
    "42879"
  ],
  "./desktop/Cartoons.scss": [
    "68017",
    7,
    "77048"
  ],
  "./mobile/": [
    "69402",
    9,
    "9598",
    "11975",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "45681",
    "64224",
    "74504",
    "58857"
  ],
  "./mobile/Cartoons": [
    "83259",
    9,
    "9598",
    "45681",
    "74504",
    "57625"
  ],
  "./mobile/Cartoons.scss": [
    "18503",
    7,
    "86714"
  ],
  "./desktop/Cartoons": [
    "97405",
    9,
    "9598",
    "11088",
    "45681",
    "3091"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 34729;
module.exports = __rspack_async_context;
